<template>
  <div>
    <div class="w-50 w-sm-100 m-md-auto mobile pt-2" >
      <div class="">
        <VerifyLayoutNew
          :auth="this.$route.meta.auth"
          :hideChangeOption="true"
        ></VerifyLayoutNew>
      </div>
    </div>
  </div>
</template>

<script>
import { SHELL_APP_HEADER_ICON } from "../mixins/Global";
import VerifyLayoutNew from "../VerifyLayout.vue";
export default {
  components: {
    VerifyLayoutNew,
  },
  async created(){
     this.$store.commit("projects/SET_HEADER_TITLE", {
      title: this.$route.meta.title,
      showBackIcon: false,
    });
    this.sendPostMessageToShellApp("UI_CHANGE", {
        headerTitle: this.$route.meta.title,
        setHeaderIcon: SHELL_APP_HEADER_ICON.BACK,
    });
  },
  mounted() {
    try {
      // send conversion event on verify mobile screen
      window && window.triggerConversionOnVerifyMobileView && window.triggerConversionOnVerifyMobileView()
    }
    catch(err) {
      throw err
    }
  }
};
</script>

<style scoped>
</style>
